import Params               from "dashboard/dist/Core/Params";
import { setSection }       from "Actions/Core/CoreActions";
import { StrechClass }      from "Utils/API";

// Types
import {
    STRECH_CLASS, STRECH_CLASS_LOADING, STRECH_CLASS_CHARGING,
    STRECH_CLASS_LIST, STRECH_CLASS_ELEM,
    STRECH_CLASS_EDIT, STRECH_CLASS_CREATE,
} from "Utils/Types";



/**
 * Fetches the Class List
 * @param {String=} type
 * @param {Number=} elemID
 * @param {Object=} params
 * @returns {(dispatch: Function) => Void}
 */
export function fetchClasses(type = "", elemID = 0, params = {}) {
    return async (dispatch) => {
        dispatch({ type : STRECH_CLASS_LOADING });
        Params.unset(params);
        let data = {};

        switch (type) {
        case "STRECH":
            params.strechID = elemID;
            data = await StrechClass.getAllForStrech(params);
            break;
        default:
        }
        data.sort = params;
        dispatch({ type : STRECH_CLASS_LIST, data });
        dispatch(setSection(STRECH_CLASS));
    };
}

/**
 * Fetches a single Class
 * @param {Number}   strechClassID
 * @param {Boolean=} withLoader
 * @returns {(dispatch: Function) => Void}
 */
export function fetchClass(strechClassID, withLoader = false) {
    return async (dispatch) => {
        if (withLoader) {
            dispatch({ type : STRECH_CLASS_CHARGING });
        }
        const data = await StrechClass.getOne({ strechClassID });
        dispatch({ type : STRECH_CLASS_ELEM, data });
    };
}

/**
 * Fetches the Class Edit data
 * @param {Number} strechClassID
 * @returns {(dispatch: Function) => Void}
 */
export function fetchClassEdit(strechClassID) {
    return async (dispatch) => {
        const data = await StrechClass.getEditData({ strechClassID });
        dispatch({ type : STRECH_CLASS_EDIT, data });
    };
}

/**
 * Fetches the Class Create data
 * @param {Number} strechID
 * @returns {(dispatch: Function) => Void}
 */
export function fetchClassCreate(strechID) {
    return async (dispatch) => {
        const data = await StrechClass.getCreateData({ strechID });
        dispatch({ type : STRECH_CLASS_CREATE, data });
    };
}



/**
 * Edits/Creates a Class
 * @param {Object} data
 * @returns {() => Void}
 */
export function editClass(data) {
    return () => StrechClass.edit(data);
}

/**
 * Edits/Creates a Class Date
 * @param {Object} data
 * @returns {() => Void}
 */
export function editClassDate(data) {
    return () => StrechClass.editDate(data);
}

/**
 * Edits/Creates a Class Date
 * @param {Number} strechClassID
 * @param {String} feedback
 * @returns {() => Void}
 */
export function editClassFeedback(strechClassID, feedback) {
    return () => StrechClass.editFeedback({ strechClassID, feedback });
}

/**
 * Deletes a Class
 * @param {Number} strechClassID
 * @returns {() => Void}
 */
export function deleteClass(strechClassID) {
    return () => StrechClass.delete({ strechClassID });
}

/**
 * Imports Classes
 * @param {Number} strechID
 * @param {String} date
 * @returns {() => Void}
 */
export function importClasses(strechID, date) {
    return () => StrechClass.import({ strechID, date });
}
